export enum VinSessionActionTypes {
    setSelectedVin = 'SET_SELECTED_VIN',
    setIsVinLoading = 'SET_IS_VIN_LOADING',
    setSelectedFilters = 'SET_SELECTED_FILTERS',
    setTitle = 'SET_TITLE',
    setVinBannerOpen = 'SET_VIN_BANNER_OPEN',
    setVinQmrsCount = 'SET_VIN_QMRS_COUNT',
    setPublicationsCount = 'SET_PUBLICATIONS_COUNT',
    setVinTechlineCasesCount = 'SET_VIN_TECHLINE_CASES_COUNT',
    setToastMessage = 'SET_TOAST_MESSAGE',
    setHasPublicationsCountFetched = 'SET_HAS_PUBLICATIONS_COUNT_FETCHED',
    setHasQmrsCountFetched = 'SET_HAS_QMRS_COUNT_FETCHED',
    setHasVinDataFetched = 'SET_HAS_VIN_DATA_FETCHED',
    setSessionStarted = 'SET_SESSION_STARTED',
    setSessionEnded = 'SET_SESSION_ENDED',
    resetState = 'RESET_STATE',
}
